import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import ArrowForward from '@material-ui/icons/ArrowForward';
import Refresh from '@material-ui/icons/Refresh';

class Controls extends React.Component {

  render() {

    const handleClickOnNext = this.props.onNext;
    const handleClickOnRandom = this.props.onRandom;
    const handleClickOnPrevious = this.props.onPrevious;

    return(
      <div className="controlBar">
          <IconButton onClick={handleClickOnPrevious}>
            <ArrowBack color="primary" fontSize="default"/>
          </IconButton>
          <IconButton onClick={handleClickOnRandom}>
            <Refresh color="primary" fontSize="default"/>
          </IconButton>
          <IconButton onClick={handleClickOnNext}>
            <ArrowForward color="primary" fontSize="default"/>
          </IconButton>
      </div>
    );
  }
}

export default Controls;